import ApiBase from '../../../api-base'
import { ACTIVE_BASE_REST } from '../../../constants'
export default class FurnitureCarTariff extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/tariff/furniture/car'
    super(store, path)
  }
}
